define([
	"dojo/_base/declare",
	"csi/action/Delete"
], function(declare,Delete) {

	return declare(Delete, {
		// Boolean: indicates if Delete action actually only removes reference from parent to child node
		// no Material Administrator access is needed in order to delete MaterialAvailability node
		bRemove: true
	});
});